import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Employee',
  moduleId: MODULE_ID,
  api: 'employee',

  routeHandler,
};

export default module;
